// extracted by mini-css-extract-plugin
export default {"container":"Battery_container__VX+3d","value":"Battery_value__Pq+kQ"};